import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useTable } from "react-table";
import { useDispatch, useSelector } from "react-redux";
import { deleteCoupon } from "../../store/reducers/couponSlice";
import { getPaymentList } from "../../utils/api/apis";
import { ReactComponent as SearchNew } from "../../assets/icons/search-svgrepo-com (1).svg";
import { ReactComponent as CopyIcon } from "../../assets/icons/CopyIcon.svg";
import { ReactComponent as BrandCopyIcon } from "../../assets/icons/BrandCopyIcon.svg";

import { returnErrors } from "../../store/reducers/error";
import { setIsLoading } from "../../store/reducers/authSlice";
import moment from "moment";
import Select from "react-select";
import { statusClassMap } from "../../utils/string";
import { Pagination } from "@mui/material";
import { toast } from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import { formatCurrency } from "../../utils/helpers/string";
import { customStyles } from "../FundingEvaluation/CreateTradingAccount";

function PaymentListTable() {
  const handleNavigateToOverView = async (value) => {
    // dispatch(setIsLoading(true));
  };

  const [searchedUser, setSearchUser] = useState([]);
  const [searchDropDown, setSearchDropDown] = useState(false);
  const [search, setSearch] = useState(null);
  const dropdownRef = useRef(null);
  const { selectedBrand } = useSelector((state) => state.brand);

  const planOptions = [
    { label: "All", value: null },
    { label: "1 Step EE", value: "1 Step EE Challenge" },
    { label: "2 Step EE", value: "2 Step EE Challenge" },
    ...(selectedBrand?.brand === "equity_edge"
      ? [
          { label: "1 Step Swift", value: "1 Step Swift Challenge" },
          { label: "2 Step Swift", value: "2 Step Swift Challenge" },
          { label: "Pro Edge Account", value: "Pro Edge account" },
        ]
      : [
          {
            label: "Crypto Edge Instant Funding",
            value: "Crypto Edge Instant Funding",
          },
        ]),
  ];
  const statusOptions = [
    { label: "All", value: null },
    { label: "Open", value: "open" },
    { label: "Succeeded", value: "succeeded" },
  ];
  const [plan, setPlan] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };

  const [isDeleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [deleteConfirmationModalContent, setDeleteConfirmationModalContent] =
    useState(null);
  const [platform, setPlatform] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <div className="payments_table">
      <div className="table_scroll_wrapper">
        <div className="alltable">
          <div className="alltable_header">
            <form
              // style={{ marginTop: "20px" }}
              className="search_container"
              onSubmit={(e) => {
                e.preventDefault();
                setSearch(searchValue);
                // setSearchValue()
                setCurrentPage(1);
              }}
            >
              <input
                type="text"
                placeholder="Search..."
                onChange={handleSearchChange}
              />
              <button type="submit">
                <div
                  style={{ padding: "3px 10px 0 0", width: "20px !important" }}
                >
                  <SearchNew width={"20px"} />
                </div>
              </button>
            </form>
            <div className="sort_buttons">
              <div className="mobile_dropDowns">
                <Select
                  placeholder="Plan Type"
                  classNamePrefix="react-select"
                  options={planOptions}
                  value={plan}
                  onChange={(selectedOption) =>
                    selectedOption.value === null
                      ? setPlan(null)
                      : setPlan(selectedOption)
                  }
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "6px",
                  width: "100%",
                }}
                className="desktop_pills"
              >
                <p>Plans</p>
                <div
                  style={{
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  {/* {planOptions.map((tab, index) => (
                    <div
                      key={index}
                      className={
                        plan && plan.label === tab.label
                          ? "active"
                          : "normalbtn"
                      }
                    >
                      {tab.label}
                    </div>
                  ))} */}
                  <Select
                    styles={customStyles}
                    options={planOptions}
                    onChange={(option) => setPlan(option)}
                    className="email-selector"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>

              <div className="line"></div>

              <div className="mobile_dropDowns">
                <Select
                  placeholder="Status"
                  classNamePrefix="react-select"
                  options={statusOptions}
                  value={status}
                  onChange={(selectedOption) =>
                    selectedOption.value === null
                      ? setStatus(null)
                      : setStatus(selectedOption)
                  }
                />
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "6px",
                  width: "100%",
                }}
                className="desktop_pills"
              >
                <p>Status</p>
                <div
                  style={{
                    flex: "1",
                    display: "flex",
                    gap: "10px",
                    width: "100%",
                  }}
                >
                  {statusOptions.map((tab, index) => (
                    <div
                      key={index}
                      className={
                        status && status.label === tab.label
                          ? "active"
                          : "normalbtn"
                      }
                      onClick={() => setStatus(tab)}
                    >
                      {tab.label}
                    </div>
                  ))}
                </div>
              </div>
              {selectedBrand?.brand === "equity_edge" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    width: "100%",
                  }}
                  className="desktop_pills"
                >
                  <p>Platform</p>
                  <div
                    style={{
                      flex: "1",
                      display: "flex",
                      gap: "10px",
                      width: "100%",
                    }}
                  >
                    <div
                      className={
                        platform === "matchtrade" ? "active" : "normalbtn"
                      }
                      onClick={() => {
                        setCurrentPage(1);
                        setPlatform("matchtrade");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Matchtrade
                    </div>
                    <div
                      className={
                        platform === "tradelocker" ? "active" : "normalbtn"
                      }
                      onClick={() => {
                        setCurrentPage(1);
                        setPlatform("tradelocker");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Tradelocker
                    </div>
                    <div
                      className={platform === "mt5" ? "active" : "normalbtn"}
                      onClick={() => {
                        setCurrentPage(1);
                        setPlatform("mt5");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      MT5
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {searchDropDown && (
            <div className="challenge_dropdown" ref={dropdownRef}>
              <ul>
                {searchedUser.map((user) => (
                  <li
                    key={user.email}
                    style={{
                      position: "relative",
                      zIndex: "100",
                      backgroundColor: "#111142",
                    }}
                    onClick={() => {
                      handleNavigateToOverView(user.email);
                    }}
                  >
                    {user.email}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="table_wrapper">
            <div className="table_scroll_wrapper">
              <Table
                search={search}
                searchValue={searchValue}
                plan={plan?.value}
                currentPage={currentPage}
                status={status?.value}
                platform={platform}
                setDeleteConfirmationModalOpen={setDeleteConfirmationModalOpen}
                setDeleteConfirmationModalContent={
                  setDeleteConfirmationModalContent
                }
                setCurrentPage={setCurrentPage}
              />
            </div>
          </div>
        </div>

        {isDeleteConfirmationModalOpen && (
          <DeleteModal
            isModalOpen={isDeleteConfirmationModalOpen}
            closeModal={() => setDeleteConfirmationModalOpen(false)}
            deleteContent={deleteConfirmationModalContent}
          />
        )}
      </div>
    </div>
  );
}
const handleCopyToClipboard = (text) => {
  toast("Copied email", {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    type: "success",
    theme: "dark",
    className: "custom-toast-container",
  });
};
export default PaymentListTable;

const Table = ({
  search,
  status,
  searchValue,
  plan,
  platform,
  currentPage,
  setCurrentPage,
}) => {
  const [filter, setFilter] = useState(null);
  const [isCalender, setIsCalender] = useState(false);
  const [date, setDate] = useState(new Date());
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();
  // const coupon = useSelector((state) => state.coupon.coupon);
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [pageNumbers, setPageNumbers] = useState([]);
  console.log(search, searchValue, "status,searchValuestatus,searchValue");
  const { selectedBrand } = useSelector((state) => state.brand);

  const fetch = async () => {
    dispatch(setIsLoading(true));

    const response = await getPaymentList(
      idToken,
      search,
      status,
      plan,
      currentPage ? currentPage : 1,
      searchValue,
      platform,
      selectedBrand
    );
    if (response?.status < 399) {
      setTableData(response.data.results);

      setTotalPages(Math.ceil(response?.data?.count / 21));
    } else {
      dispatch(returnErrors("Error getting payment list"));
    }
    dispatch(setIsLoading(false));
  };
  useEffect(() => {
    fetch();
  }, [idToken, filter, search, status, plan, currentPage, platform]);

  // const data = tableData;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Pagination Logic

  // setting total pages
  useEffect(() => {
    setPageNumbers([...Array(totalPages).keys()].map((i) => i + 1));
  }, [totalPages]);

  const handlePagination = async (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [code, setCode] = useState();
  const handleDelete = (couponCode) => {
    setCode(couponCode);
  };

  const handleFilter = (status) => {
    setFilter(status);
  };

  const filteredData =
    filter === "All"
      ? tableData
      : filter === true
      ? tableData.filter((item) => item.is_active === true)
      : tableData.filter((item) => item.is_active === false);

  const columns = React.useMemo(
    () => [
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ value }) => {
          const [randomColor, setRandomColor] = useState();
          const getRandomColor = `#${Math.floor(
            Math.random() * 16777215
          ).toString(16)}`;
          if (!randomColor) {
            setRandomColor(getRandomColor);
          }

          return (
            <>
              <div className="column_one_wrapper">
                <div
                  className="sno_wrapper"
                  style={{ backgroundColor: randomColor }}
                >
                  {value.charAt(0).toUpperCase()}
                </div>
                <div>{value}</div>
                <CopyToClipboard onCopy={handleCopyToClipboard} text={value}>
                  {/* <button> */}
                  <p
                    className="table_copy_button"
                    style={{
                      marginRight: "20px",
                      cursor: "pointer",
                    }}
                  >
                    {selectedBrand?.brand === "crypto_edge" ? (
                      <BrandCopyIcon />
                    ) : (
                      <CopyIcon />
                    )}
                  </p>
                  {/* </button> */}
                </CopyToClipboard>
              </div>
            </>
          );
        },
      },
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => <td className="code">{value}</td>,
      },
      { Header: "Plan", accessor: "funding_evaluation" },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value }) => <td>{formatCurrency(Number(value) || 0)}</td>,
      },
      {
        Header: "Status",
        accessor: "payment_status",
        Cell: ({ value, row }) => (
          <span className={`status_wrapper ${statusClassMap[value]}`}>
            {value.toUpperCase()}
          </span>
        ),
      },
      {
        Header: "Created at",
        accessor: "created_at",
        Cell: ({ value }) => (
          <td>{value ? moment.utc(value).format("ll") : "NA"}</td>
        ),
      },
    ],
    []
  );
  const [inputText, setInputText] = useState("");

  // const filteredDataCoupon = tableData.filter((el) => {
  //
  //   return el.code.toLowerCase().includes(inputText);
  // });
  //

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: tableData });
  const handleChange = (e, value) => {
    setCurrentPage(value);
  };

  const [gotoPageInput, setGotoPageInput] = useState();

  const handleGotoPage = () => {
    const pageNumber = parseInt(gotoPageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setGotoPageInput("");
    }
  };
  return (
    <div className="table_wrapper">
      <div style={{ marginTop: "20px" }} className="table_scroll">
        <table {...getTableProps()} className="leaderboard-table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td
                      className={`${
                        cell.column.Header === "Status" ? "status_column" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>{" "}
      </div>
      {/* <div className="pagination">
        <img src={CaretLeftIcon} alt="" />
        <button
          style={{ color: `${currentPage === 1 ? "#a8a8a8" : "black"}` }}
          onClick={() => {
            if (currentPage === 1) {
              return;
            } else {
              handlePagination(currentPage - 1);
            }
          }}
        >
          Previous
        </button>
        <span style={{ display: "flex", gap: "15px", fontWeight: "100" }}>
          {pageNumbers.map((pageNumber, idx) => (
            <strong key={pageNumber}>
              {currentPage === pageNumber ? (
                <span
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontWeight: "900",
                  }}
                >
                  {pageNumber}
                </span>
              ) : (
                <div
                  onClick={() => {
                    handlePagination(pageNumber);
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontWeight: "20",
                    padding: "4px",
                    paddingTop: "0px",
                    paddingBottom: "0px",
                    cursor: "pointer",
                  }}
                >
                  {pageNumber}
                </div>
              )}
            </strong>
          ))}
        </span>
        <button
          style={{
            color: `${currentPage + 1 > totalPages ? "#a8a8a8" : "black"}`,
          }}
          onClick={() => {
            if (currentPage + 1 > totalPages) {
              return;
            } else {
              handlePagination(currentPage + 1);
            }
          }}
        >
          Next
        </button>
        <img src={CaretRightIcon} alt="" />
      </div> */}
      <div className="spacerT30p"></div>
      <div
        className="pagination_wrapper"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "20px 0px",
        }}
      >
        <Pagination
          onChange={handleChange}
          count={totalPages}
          variant="outlined"
          page={currentPage}
          color="primary"
        />
        <div className="goto-page-input">
          <input
            type="number"
            placeholder="Go to Page"
            value={gotoPageInput}
            onChange={(e) => setGotoPageInput(e.target.value)}
          />
          <button className="goToButton" onClick={handleGotoPage}>
            Go
          </button>
        </div>
      </div>
    </div>
  );
};

const DeleteModal = ({
  isModalOpen,
  closeModal,
  deleteContent,
  onConfirmDelete,
  idToken,
}) => {
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(deleteCoupon({ idToken: idToken, code: deleteContent }));
    closeModal();
  };

  return (
    <div className="modal">
      <div className="modal_content">
        <p>Are you sure you want to delete?</p>
        <div className="modal_btn">
          <button onClick={handleDelete}>Yes</button>
          <button onClick={closeModal}>No</button>
        </div>
      </div>
    </div>
  );
};
